import React from 'react';

const RiskFlagsDetail = ({ riskFlags }) => {
  if (!riskFlags || !riskFlags.items || riskFlags.items.length === 0) {
    return (
      <div style={{
        background: 'rgba(255,255,255,0.96)',
        borderRadius: 12,
        padding: 20,
        border: '1px solid rgba(0,0,0,0.08)'
      }}>
        <h4 style={{ margin: '0 0 16px 0', fontSize: 16, fontWeight: 700, color: '#1f2937' }}>
           Risk Flags
        </h4>
        <div style={{
          padding: 16,
          background: '#f0fdf4',
          border: '1px solid #86efac',
          borderRadius: 8,
          textAlign: 'center',
          color: '#15803d'
        }}>
          No risk flags detected - Clean trading!
        </div>
      </div>
    );
  }

  const { counts, items } = riskFlags;
  const { critical = 0, major = 0, minor = 0 } = counts || {};
  const total = items.length;

  const getSeverityColor = (severity) => {
    const colors = {
      'CRITICAL': { bg: 'var(--flag-critical-bg)', border: 'var(--flag-critical-border)', text: 'var(--flag-critical-text)' },
      'MAJOR': { bg: 'var(--flag-major-bg)', border: 'var(--flag-major-border)', text: 'var(--flag-major-text)' },
      'MINOR': { bg: 'var(--flag-minor-bg)', border: 'var(--flag-minor-border)', text: 'var(--flag-minor-text)' }
    };
    return colors[severity] || { bg: '#f9fafb', border: '#d1d5db', text: '#4b5563' };
  };

  return (
    <div style={{
      background: 'rgba(255,255,255,0.96)',
      borderRadius: 12,
      padding: 20,
      border: '1px solid rgba(0,0,0,0.08)'
    }}>
      <h4 style={{ margin: '0 0 16px 0', fontSize: 16, fontWeight: 700, color: '#1f2937' }}>
         Risk Flags Detected ({total})
      </h4>

      {/* Summary Badges */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        {critical > 0 && (
          <span style={{
            padding: '4px 12px',
            background: '#fef2f2',
            border: '1px solid #fca5a5',
            color: '#991b1b',
            borderRadius: 6,
            fontSize: 13,
            fontWeight: 700
          }}>
             {critical} Critical
          </span>
        )}
        {major > 0 && (
          <span style={{
            padding: '4px 12px',
            background: '#fff7ed',
            border: '1px solid #fdba74',
            color: '#c2410c',
            borderRadius: 6,
            fontSize: 13,
            fontWeight: 700
          }}>
             {major} Major
          </span>
        )}
        {minor > 0 && (
          <span style={{
            padding: '4px 12px',
            background: '#fefce8',
            border: '1px solid #fde047',
            color: '#854d0e',
            borderRadius: 6,
            fontSize: 13,
            fontWeight: 700
          }}>
             {minor} Minor
          </span>
        )}
      </div>

      {/* Flag List */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {items.map((flag, index) => {
          const colors = getSeverityColor(flag.severity);
          return (
            <div
              key={index}
              style={{
                padding: 12,
                background: colors.bg,
                border: `1px solid ${colors.border}`,
                borderRadius: 8
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: 4 }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: colors.text, marginBottom: 4 }}>
                    {flag.title}
                  </div>
                  <div style={{ fontSize: 12, color: '#4b5563' }}>
                    {flag.desc}
                  </div>
                </div>
                <div style={{
                  padding: '2px 8px',
                  background: colors.text,
                  color: 'white',
                  borderRadius: 4,
                  fontSize: 11,
                  fontWeight: 700,
                  whiteSpace: 'nowrap',
                  marginLeft: 8
                }}>
                  {flag.scoreText || `-${flag.penalty}`}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RiskFlagsDetail;
